import echarts from 'echarts';
const commonOptionY = {// 通用Y周配置
    axisLine: {
        lineStyle: {
            width: 0
        }
    },
    axisTick: {
        show: false
    }
};
const WAN = 10000;// 万
const MILLION = 10000000;// 千万
const HUNDRED_MILLION = 100000000;// 亿

const commonTextStyle = function(align) { // 通用Y轴字体样式
    return {
        align: align || 'right',
        color: '#333333',
        fontSize: 12,
        fontFamily: 'PingFangSC-Regular',
        fontWeight: 400
    };
};
const formatData = function(data) {
    const xData = [];
    const successList = [];
    const failList = [];
    const percentList = [];
    data.forEach(item => {
        xData.push(item.apiName);
        successList.push(item.successCount || null);
        failList.push(item.failCount || null);
        const successCountRate = (item.successCountRate).slice(0, item.successCountRate.length - 1);
        percentList.push(successCountRate);
    });
    return { xData, successList, failList, percentList };
};

export const getInCallOptions = function(data) {
    const { xData = [], successList = [], failList = [], percentList = [] } = formatData(data || []);
    return {
        color: ['#ff7c24', '#4285f5', '#00c66b'],
        legend: {
            top: '0',
            right: '0',
            itemWidth: 64,
            itemHeight: 17,
            itemGap: 30,
            data: [
                {
                    icon: `image://${require('../../../../../../assets/images/echarts-success-icon.png')}`,
                    name: '成功'
                },
                {
                    icon: `image://${require('../../../../../../assets/images/echarts-fail-icon.png')}`,
                    name: '失败'
                },
                {
                    icon: `image://${require('../../../../../../assets/images/echarts-successRate-icon.png')}`,
                    name: '成功率'
                }
            ],
            textStyle: {
                padding: [0, 0, 0, 4],
                color: '#333333',
                fontSize: 12,
                fontFamily: 'PingFangSC-Regular',
                fontWeight: 400
            }
        },
        grid: {
            top: '20%',
            right: '0%',
            bottom: '10px',
            left: '0%',
            containLabel: true
        },
        tooltip: {
            trigger: 'axis',
            confine: true,
            position: 'bottom',
            backgroundColor: 'rgba(8,8,8,.70)',
            axisPointer: {
                type: 'none'
            },
            textStyle: {
                color: '#ffffff',
                fontSize: 12,
                fontFamily: 'PingFangSC-Medium',
                fontWeight: 500
            },
            formatter: params => {
                const dataIndex = params[0].dataIndex;
                const success = (successList[dataIndex]) ? (successList[dataIndex]).toLocaleString() : 0;
                const fail = (failList[dataIndex]) ? (failList[dataIndex]).toLocaleString() : 0;
                const tooltipStr = `<div class="echarts-tooltip-box">
                <span>${params[0].axisValueLabel}</span>
                <span>成功：${success}</span>
                <span>失败：${fail}</span>
                <span>成功率：${percentList[dataIndex]}%</span>`;
                return tooltipStr;
            }
        },
        xAxis: [
            {
                type: 'category',
                data: xData,
                axisLabel: {
                    show: true,
                    margin: 12,
                    textStyle: {
                        color: '#333333',
                        fontSize: 12,
                        fontFamily: 'PingFangSC-Regular',
                        fontWeight: 400
                    },
                    formatter: (value) => {
                        return value ? value.substring(0, 5) : '';
                    }
                },
                axisLine: {
                    lineStyle: {
                        color: '#eaeaea'
                    }
                },
                axisTick: {
                    show: false
                }
            }
        ],
        yAxis: [
            {
                type: 'value',
                axisLabel: {
                    show: true,
                    margin: 10,
                    formatter: (value, index) => {
                        if (value >= WAN && value < MILLION) {
                            value = (value / WAN).toString().substring(0, 6) + '万';
                        } else if (value >= MILLION && value < HUNDRED_MILLION) {
                            value = (value / MILLION).toString().substring(0, 6) + '千万';
                        } else if (value >= HUNDRED_MILLION) {
                            value = (value / HUNDRED_MILLION).toString().substring(0, 6) + '亿';
                        }
                        return value;
                    },
                    textStyle: commonTextStyle()
                },
                splitLine: {
                    show: true,
                    lineStyle: {
                        color: '#e8e8e8',
                        type: 'dashed'
                    }
                },
                ...commonOptionY
            },
            {
                type: 'value',
                minInterval: 50,
                min: 0,
                max: 100,
                axisLabel: {
                    show: true,
                    margin: 10,
                    formatter: (value) => {
                        return value ? value + '%' : value;
                    },
                    textStyle: commonTextStyle('left')
                },
                splitLine: {
                    show: false
                },
                ...commonOptionY
            }
        ],
        series: [
            {
                name: '失败',
                type: 'bar',
                stack: 'statis',
                barWidth: 22.85,
                data: failList,
                barMinHeight: 5
            },
            {
                name: '成功',
                type: 'bar',
                stack: 'statis',
                barWidth: 22.85,
                data: successList,
                itemStyle: {
                    barBorderRadius: [2, 2, 0, 0]
                },
                barMinHeight: 5
            },
            {
                name: '成功率',
                type: 'line',
                hoverAnimation: false,
                smooth: true,
                symbol: 'circle',
                symbolSize: [ 8, 8 ],
                yAxisIndex: 1,
                data: percentList,
                areaStyle: {
                    normal: {
                        color: new echarts.graphic.LinearGradient(
                            0, 0, 0, 1,
                            [
                                {
                                    offset: 0,
                                    color: 'rgba(0,198,107, 0.22)'
                                },
                                {
                                    offset: 1,
                                    color: 'rgba(0,198,107, 0)'
                                }
                            ]
                        )
                    }
                },
                itemStyle: {
                    color: '#00c66b',
                    borderColor: '#ffffff',
                    borderWidth: 1,
                    lineStyle: {
                        width: 0.5,
                        color: '#00c66b'
                    }
                }
            }
        ]
    };
};
